import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { BehaviorSubject, catchError, filter, Observable, switchMap, take, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

let isRefreshing = false;
const refreshDone$ = new BehaviorSubject<string | null>(null);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();
    const headers: Record<string, string> = {
      'x-app-type': 'admin',
    };
    if (token && !request.url.includes('cloudinary.com')) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    request = request.clone({
      setHeaders: headers,
      withCredentials: true,
    });

    return next.handle(request).pipe(
      catchError(err => {
        if (err.status === 401 && !request.url.includes('auth/refresh') && !request.url.includes('auth/login') && !request.url.includes('auth/adminlogin') && !request.url.includes('auth/logout')) {
          return this.handle401(request, next);
        }
        return throwError(() => err);
      })
    );
  }

  private handle401(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (isRefreshing) {
      return refreshDone$.pipe(
        filter(t => t !== null),
        take(1),
        switchMap(newToken =>
          next.handle(req.clone({
            setHeaders: { Authorization: `Bearer ${newToken}` },
            withCredentials: true,
          }))
        )
      );
    }

    isRefreshing = true;
    refreshDone$.next(null);

    return this.authService.refreshTokens().pipe(
      switchMap((res: any) => {
        isRefreshing = false;
        refreshDone$.next(res.token);
        return next.handle(req.clone({
          setHeaders: { Authorization: `Bearer ${res.token}` },
          withCredentials: true,
        }));
      }),
      catchError(refreshErr => {
        isRefreshing = false;
        refreshDone$.next(null);
        this.doLogout();
        return throwError(() => refreshErr);
      })
    );
  }

  private doLogout(): void {
    this.authService.logout();
    // Vuelve al login avisando que la sesión venció y recordando dónde estaba.
    this.router.navigate(['auth/login'], { queryParams: { expired: 1, returnUrl: this.router.url } });
  }
}
